import { useUserSession } from './useUserSession';

/**
 * Hook de compatibilité pour useAuth
 * @deprecated Utilisez useUserSession à la place
 */
export function useAuth() {
  const {
    isUserAuthenticated,
    isLoading,
    isTwitchConnected,
    isSpotifyConnected,
    getTwitchUser,
    getSpotifyUser,
    disconnectTwitch,
    disconnectSpotify,
  } = useUserSession();

  return {
    isAuthenticated:
      isUserAuthenticated || isTwitchConnected() || isSpotifyConnected(),
    isLoading,
    authError: null, // Plus géré ici
    twitchUser: getTwitchUser,
    spotifyUser: getSpotifyUser,
    logoutTwitch: disconnectTwitch,
    logoutSpotify: disconnectSpotify,
  };
}
